import {Injectable} from '@angular/core';
import {Observable, shareReplay} from 'rxjs';
import {ReturnFlag} from '../stock/stock.service';
import { BaseService, RequestOptions } from 'src/app/services/base.service';

@Injectable({
	providedIn: 'root',
})

export class AdvanceDashboardService {
	private icondata$: Observable<any>;

	constructor(private readonly baseService: BaseService) { }

	dashboardList(): Observable<any> {
		return this.baseService.get<any>('DashboardCrud/GetDashboardsInfo');
	}

	AddNewDashboardMenu(Action: DashboardAction): Observable<ReturnFlag> {
		return this.baseService.post<ReturnFlag>(
			'DashboardCrud/AddNewDashboardMenu',
			Action,
		);
	}

	GetDashboardMenus(DashboardId: string, requestOptions?: Partial<RequestOptions>): Observable<any> {
		return this.baseService.post<ReturnFlag>(
			'DashboardCrud/GetDashboardMenus?id=' + encodeURIComponent(DashboardId),
			requestOptions,
		);
	}

	DeleteDashboardData(DashboardId: string): Observable<any> {
		return this.baseService.post<ReturnFlag>('DashboardCrud/DeleteDashboardData?id=' + encodeURIComponent(DashboardId));
	}

	GetIcons(): Observable<any> {
		if (!this.icondata$) {
			this.icondata$ = this.baseService.post('DashboardCrud/GetIcons').pipe(
				shareReplay(1),
			);
		}

		return this.icondata$;
	}

	TestDynamicDashbaord(Action: string): Observable<any> {
		return this.baseService.post<any>(
			'DashboardCrud/DynamicDashboardApisQuery',
			{data: Action},
		);
	}

	GetDashboards(): Observable<any> {
		if (!this.icondata$) {
			this.icondata$ = this.baseService.post('DashboardCrud/GetIcons').pipe(
				shareReplay(1),
			);
		}

		return this.icondata$;
	}

	GetDashboardsMenuAccess(RoleId: number): Observable<any> {
		return this.baseService.post<ReturnFlag>('DashboardCrud/GetDashboardsMenuAccess?id=' + RoleId);
	}

	SavingDashboardsMenuAccess(menuDashboardItems: DashboardAccess, requestOptions?: Partial<RequestOptions>): Observable<any> {
		return this.baseService.post<ReturnFlag>(
			'DashboardCrud/SavingDashboardsMenuAccess',
			menuDashboardItems,
			requestOptions,
		);
	}

	ClearCacheDashboard(dashboardId: string) {
		return this.baseService.get<any>('DashboardCrud/ClearCacheDashboard?Id=' + dashboardId);
	}
}

export class DashboardAction {
	title: string;
	dashboardId: string;
	menuIcon: string;
	IsEnableCache: boolean;
}

export class DashboardAccess {
	Items: DashboardUpdate[];
	Id: number;
}

export class DashboardUpdate {
	DashboardId: number;
	IsActive: boolean;
}